import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "email",
    "emailError",
    "sendButton"
  ];

  connect() {
    this.sendButtonTarget.disabled = true;
    this.debouncedValidate = this.#debounce(this.validateForm.bind(this), 400);
  }

  validateForm() {
    const email = this.emailTarget?.value || "";
    const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    // check email validity
    if (this.hasEmailErrorTarget) {
      if (!email && this.emailErrorTarget) {
        this.emailErrorTarget.classList.add("hidden");
      } else if (!emailValid) {
        this.emailErrorTarget.textContent = "Enter a valid email.";
        this.emailErrorTarget.classList.remove("hidden");
      } else {
        this.emailErrorTarget.classList.add("hidden");
      }
    }

    if(emailValid){
      this.sendButtonTarget.disabled = false;
    } else {
      this.sendButtonTarget.disabled = true;
    }
  }

  // i guess is not a bad idea this function to be private hence the # prefix
  #debounce(func, wait) {
    let timeout;
    return (...args) => {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}
